module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "usedcars.73b69e6d.svg";